 (() => {
    if (window.__klipBlumPopupBridgeInstalled) return;
    window.__klipBlumPopupBridgeInstalled = true;

    function getCurrentVariantId() {
      const focusedForm = document.activeElement?.closest(
        'form[action*="/cart/add"]'
      );

      const visibleForm = Array.from(
        document.querySelectorAll(
          'ecx-prd-frm form[action*="/cart/add"]'
        )
      ).find(form => form.offsetParent !== null);

      const form =
        focusedForm ||
        visibleForm ||
        document.querySelector('ecx-prd-frm form[action*="/cart/add"]');

      const variantInput =
        form?.querySelector('[name="id"]:not(:disabled)') ||
        form?.querySelector('[name="id"]');

      return Number(variantInput?.value || 0);
    }

    document.addEventListener('klip:volume:atc', () => {
      const variantId = getCurrentVariantId();

      if (!variantId) return;
      if (!document.querySelector('ecx-cart-noti')) return;
      if (typeof window.ECXHelper?.forceUpdateCartStatus !== 'function') return;

      window.ECXHelper.forceUpdateCartStatus({
        id: variantId
      });
    });
  })();
